/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDistrictQueryResult } from '../../models/get-district-query-result';

export interface ApiDistrictGetDistrictGet$Params {
  Id?: string;
}

export function apiDistrictGetDistrictGet(http: HttpClient, rootUrl: string, params?: ApiDistrictGetDistrictGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDistrictQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiDistrictGetDistrictGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDistrictQueryResult>;
    })
  );
}

apiDistrictGetDistrictGet.PATH = '/api/District/GetDistrict';
